// Ô vật phẩm (UI_SPEC §10.2): MỘT khuôn cho mọi thứ đựng được. 4 cỡ, 5 lớp, 4 góc cố định nghĩa.
// TL hệ · TR trạng thái · BL Giai · BR số lượng / cường hóa. Tên không nằm trong ô.
import type { JSX } from 'preact';
import { Icon, type IconName } from '../icons';

export type SlotSize = 'sm' | 'md' | 'lg' | 'xl';
export type SlotSignal = 'equipped' | 'new' | 'task' | 'better' | null;

export function ItemSlot(props: {
  size?: SlotSize;
  /** Class phẩm (`q-hoang`…); không có thì viền trung tính. */
  q?: string;
  art?: string | null;
  glyph?: IconName;
  /** Class hệ (`el-kim`…) cho góc TL. */
  el?: string;
  signal?: SlotSignal;
  bl?: string;
  br?: string;
  state?: 'normal' | 'empty' | 'locked' | 'off';
  selected?: boolean;
  id?: string;
  label?: string;
  onClick?: () => void;
}): JSX.Element {
  const size = props.size ?? 'md';
  const state = props.state ?? 'normal';
  const cls = [
    'ht-item',
    `o-${size}`,
    props.q,
    props.selected ? 'selected' : null,
    props.signal === 'equipped' ? 'equipped' : null,
  ]
    .filter(Boolean)
    .join(' ');
  const body = (
    <>
      {props.art ? (
        <img class="it-art" src={props.art} alt="" draggable={false} />
      ) : props.glyph && state !== 'empty' ? (
        <span class="it-art pending" data-art="pending">
          <Icon name={props.glyph} />
        </span>
      ) : null}
      {props.el && <i class={`it-tl ${props.el}`} />}
      {props.signal && <i class={`it-tr ${props.signal}`} />}
      {props.bl && <b class="it-bl">{props.bl}</b>}
      {props.br && <b class="it-br">{props.br}</b>}
      {state === 'locked' && (
        <span class="it-lock">
          <Icon name="lock" />
        </span>
      )}
    </>
  );
  return props.onClick ? (
    <button
      type="button"
      class={cls}
      data-state={state}
      data-id={props.id}
      aria-label={props.label}
      onClick={props.onClick}
    >
      {body}
    </button>
  ) : (
    <div class={cls} data-state={state} data-id={props.id} aria-label={props.label}>
      {body}
    </div>
  );
}
